// extracted by mini-css-extract-plugin
module.exports = {"notice":"_903e030"};